module.exports = __webpack_public_path__ + "static/media/cookies.28598799.svg";